import React from 'react'
import ReportsDateSelect from '../../commons/ReportsDateSelect/ReportsDateSelect'
type AppProps = {
    startDate?: string;
    endDate?: string;
    handleStartDateChange: (date: string) => void;
    handleEndDateChange: (date: string) => void;
    handleSubmitData?: () => void;
    toggle: boolean;
    setToggle: (data: boolean) => void;
  }

const GeneralLedgerHeader = ({
    startDate,
    endDate,
    handleStartDateChange,
    handleEndDateChange,
    handleSubmitData,
    toggle,
    setToggle
}:AppProps) => {
    return (
        <div className='d-flex justify-content-start align-items-center'>
          <div className='form-group'>
            <label className='mb-1'>Date</label>
            <div>
              <ReportsDateSelect
                setToggle={setToggle}
                toggle={toggle}
                startDate={startDate?startDate:""}
                endDate={endDate?endDate:""}
                handleStartDateChange={handleStartDateChange}
                handleEndDateChange={handleEndDateChange}
                type={"generalLedger"}
              />
            </div>
          </div>
          <div className="col-md-3 mt-2">
            <button
              className="btn btn-primary"
              onClick={handleSubmitData}
              disabled={!startDate?.length || !endDate?.length}
            >
              Get Report
            </button>
          </div>
        </div>
      )
}

export default GeneralLedgerHeader;